@if (date) {
  <ma-date [date]="date" [isSelected]="isSelected"></ma-date>
} @else {
  <div translate [className]="isSelected ? 'white' : 'red'">Not executed</div>
}
